export const DEFAULT_CURRENCY = 'RUBL';
export const DEFAULT_TIMEZONE = 3;
export const DEFAULT_LANG = 'ru';
export const AVAILABLE_LANGS = ['ru', 'en'];
export const ADMIN_ID = 500001;
export const ONLY_CURRENCY: string | null = null;
export const EXCLUDED_CURRENCY: string[] | null = null;
export const COMPANY_NAME = 'Донская академия тенниса';
